<template>
  <v-breadcrumbs :items="items">
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
          :href="item.href"
          :disabled="item.disabled"
      >
        {{ item.text.toUpperCase() }}
      </v-breadcrumbs-item>
    </template>

  <div class="card_container" >
      <div v-if="is_loading" class="loading-container" >
        <img src="../../assets/loading.svg" >
      </div>
      <div class="card_header" >
        <h2>รายละเอียดสินค้า</h2>
        <div class="date-picker-container" >
        </div>
      </div>
      <div class="table-report-container" align="center" >
        <table ref="table" border="1" >
          <tr>
            <td style="border: none; text-align: center; vertical-align: middle;padding: 1rem"   align="center" colspan="2" >

              <img v-if="logo" style="margin-top: 10px;" width="150" :src="logo" />
              <img v-else style="margin-top: 10px;" width="150" src="https://app.yn-engineering.com/logo.png" />

            </td>
            <td style="border: none; text-align: center; vertical-align: middle;padding: 1rem" colspan="2" align="center" >
              <br><br>
              <p v-html="address"  style="width: 60%" >
              </p>
            </td>

          </tr>
          <tr>
            <th>ลำดับที่</th>
            <th>ประเภทสินค้า</th>
            <th>รหัสสินค้า</th>
            <th>รายละเอียดสินค้า</th>
          </tr>

          <tr v-for="(result, index) in resultData" v-bind:key="result.id"  >
            <td>{{ (index+1) }}</td>
            <td>{{ result.categories.title }}</td>
            <td>{{ result.code }}</td>
            <td>{{ result.description }}</td>
          </tr>

        </table>
      </div>
      <div align="center" >
        <button class="btn-export" type="button" @click="tableToExcel()"> ส่งออกข้อมูล </button>
      </div>
    </div>
  </v-breadcrumbs>


</template>

<script>
import {DeleteProduct, GetMachine, GetStockReport} from "../../lib/controller";
import {api_report, baseUrl} from "../../const/api";




export default {
  name: "Users",
  data: () => (
      {
    resultData:{},
    machine_id: 99,
        machine:{},
    machine_item: {},
    param: {},
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu: false,
    modal: false,
        is_loading:false,
    menu2: false, address:'บริษัท วายเอ็น เอ็นจิเนียริ่ง โซลูชั่น จำกัด<br>' +
            'เลขที่ 2/8 ถ.รามคำแหง แขวงมีนบุรี เขตมีนบุรี กทม.10510<br>' +
            'โทร .02-917-5536 แฟกซ์ 02-917-5537',
        address_default:'บริษัท วายเอ็น เอ็นจิเนียริ่ง โซลูชั่น จำกัด<br>' +
            'เลขที่ 2/8 ถ.รามคำแหง แขวงมีนบุรี เขตมีนบุรี กทม.10510<br>' +
            'โทร .02-917-5536 แฟกซ์ 02-917-5537',
        logo:"",
    uri :'data:application/vnd.ms-excel;base64,',
    template:'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
    base64: function(s){ return window.btoa(unescape(encodeURIComponent(s))) },
    format: function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
  }
  ),
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
  },
  watch: {

  },
  created () {
    this.initialize()

    const user = JSON.parse(localStorage.getItem('user'));
    console.log(user.machine_id)
    this.machine_id = user.machine_id;

    this.GetMachines()
  },

  methods: {
    async GetMachines(){
      let machine = [];
      const { status , results } = await GetMachine();
      if(status === 200){

        machine.push({
          "label":"ทั้งหมด",
          "id":99,
        })

        results.data.forEach(function (result){
          console.log(result)
          machine.push({
            "label":result.title,
            "id":result.machine_number,
          })
        });
      }

      this.machine_item = machine;
      this.machine = results.data;
      this.getData()
      console.log(this.machine_item)

    },
    tableToExcel(){
      console.warn(new URLSearchParams(this.param).toString());
      console.warn(api_report);
      window.location = api_report+"/report-product-detail?"+ new URLSearchParams(this.param).toString();
    },
   async editItem(id) {
     this.$router.push({ path: '/Product/'+id })
    },
    async deleteItem(id){
      console.log(id)
      this.$swal({
        title: 'ต้องการลบใช่หรือไม่ ?',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText:"ยกเลิก",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            this.delete(id)
        }
      })

      ;
    },
    initialize () {

    },
   async getData(){


     let params = {};



     params.machine_id = this.machine_id

     this.is_loading = true;

     const match = this.machine.find(item => item.machine_number === this.machine_id);

     if (match) {
       if (match.logo) {
         this.logo = baseUrl + '/' + match.logo.path.replace('media', '');
       }else{
         this.logo = "";
       }
       if (match.address) {
         this.address = match.address;
       }else{
         this.address = this.address_default;
       }
     }

     this.param = params;

      const { status,results } = await GetStockReport(params);

     this.is_loading = false;

      if(status === 200){

        let uniqueIds = new Set();
        let uniqueArray = results.data.filter(item => {
          const isDuplicate = uniqueIds.has(item._id);
          uniqueIds.add(item._id);
          return !isDuplicate;
        });

        this.resultData = uniqueArray;
      }
    },
    async delete(id){
      let Swal = this.$swal;
      const { status } = await DeleteProduct(id);
      if(status === 200){
        Swal({
          icon: 'success',
          title: 'Success',
        })
       await this.getData()
      }
    },

  },
}


</script>

<style scoped>
.card_container{
  width: 100%;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: border-box;
  border: 1px solid #EBEDF3;
  border-radius: 0.42rem;
}
.card_header{
  padding: 1.5rem 2rem;
  margin-bottom: 0;
  background-color: #ffffff;
  border-bottom: 1px solid #EBEDF3;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.img_thumb{
  width:8rem;
  border-radius:10px;
  margin:0.2rem;
}
.date-picker-container{
  display: flex;
  column-gap: 10px;
}
.table-report-container{

}
.table-report-container > table{
  width: 70%;
  border:1px solid #000;
  border-collapse: collapse;
}
</style>
